const moneyFormatter = new Intl.NumberFormat('ru-RU', {
  style: 'currency',
  currency: 'RUB',

  // These options are needed to round to whole numbers if that's what you want.
  //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  maximumFractionDigits: 0,
})

const money = v => {
  return moneyFormatter.format(v);
}

const percent = v => {
  return (Math.round(v * 10000)/10000) + '%'
}

export { money, percent, moneyFormatter }
